import React from "react";
import styled from "styled-components";

const Dots = styled.div`
    align-items: center;
    display: flex;
    gap: 5px;
    justify-content: space-between;
    left: 0;
    padding: 0 16px;
    position: fixed;
    top: 16px;
    width: 100%;
    z-index: 100001;
`;

const Dot = styled.div<{ progress: number, paused: boolean }>`
    background: #888;
    border-radius: 3px;
    height: 3px;
    transition: background 0.3s ease;
    width: 100%;

    &::after {
        background: white;
        content: '';
        display: block;
        height: 100%;
        ${({ paused, progress }) => `
            ${progress === -1 && 'width: 0;'}
            ${progress === 1 && 'width: 100%;'}
            ${progress === 0 && `
                width: 0;
                animation: fillDot 8s linear ${paused ? 'paused' : 'forwards'};
                @keyframes fillDot {
                    from { width: 0%; }
                    to { width: 100%; }
                }
            `}
        `}
    }
`;

const StoryTrail = ({ current, paused, total }) => {
    return (
        <Dots>
            {Array.from({ length: total }, (_, index) => (
                <Dot key={index} progress={index < current ? 1 : index > current ? -1 : 0} paused={paused} />
            ))}
        </Dots>
    );
}

export default StoryTrail;